module.exports = __webpack_public_path__ + "static/ppp-recipe-demo-screenshot.67513802.jpg";